import React from 'react'
import { Trans } from '@lingui/react/macro'

import {
  getConcurrentMusicGenerationLabel,
  getPlanFeatureItems,
  getPlanWordsText,
} from '../planDisplayContent'

import { EPaidProductType, EProductType } from '@/contexts/PlanContext/type'

const featuresTitle = <Trans>Features:</Trans>

export const PlanFeatureMap = {
  [EProductType.FREE]: {
    requestWords: getConcurrentMusicGenerationLabel,
    wordsText: getPlanWordsText,
    featuresTextList: getPlanFeatureItems,
    featuresTitle,
  },
  [EPaidProductType.BASIC]: {
    requestWords: getConcurrentMusicGenerationLabel,
    wordsText: getPlanWordsText,
    featuresTextList: getPlanFeatureItems,
    featuresTitle,
  },
  [EPaidProductType.PRO]: {
    requestWords: getConcurrentMusicGenerationLabel,
    wordsText: getPlanWordsText,
    featuresTextList: getPlanFeatureItems,
    featuresTitle,
  },
  [EPaidProductType.UNLIMITED]: {
    requestWords: getConcurrentMusicGenerationLabel,
    wordsText: getPlanWordsText,
    featuresTextList: getPlanFeatureItems,
    featuresTitle,
  },
}
